// HACK: Phase4Step5の終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
// 指摘内容は1ファイルの最大行数（500行）の超過であるため、処理内容自体の問題はないと判断。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import cstmTable from "../../../../share/components/vue/PaginationTable";
import individualDiagnose from '../../../../share/util/individualDiagnose';
import api from '@/common/api';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  WAIT: 'wait',
  AREA_SELECT: 'areaSelect',
  UPDATE_WAIT: 'updateWait',
  UPDATE_SUCCESS: 'updateSuccess',
  USB_DISCONNECT: 'usbDisconnect',
  SUCCESS: 'success',
  USB_UNCONNECTED: 'usbUnconnected',
  UPDATE_NOT_APPLICABLE: 'updateNotApplicable',
  VEHICLE_ABNORMALITY: 'vehicleAbnormality',
  UPDATE_FAILED: 'updateFailed',
  FAILED: 'failed',
};

export default {
  name: 'requirement100',
  data() {
    return {
      phase: PHASE.START,
      progress: '',
      isLoading: false,
      systemId: '',
      bodyItems: [],
      requestId: '',
      updateFailureReference: '',
      modal_requirement_100: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },
  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      netAppId: (state) => state.netAppConnector.pairingAppId
    }),

    /** ダイアログのヘッダー色 */
    headerColor() {
      switch (this.phase) {
        case PHASE.USB_UNCONNECTED:
        case PHASE.UPDATE_NOT_APPLICABLE:
        case PHASE.VEHICLE_ABNORMALITY:
        case PHASE.UPDATE_FAILED:
        case PHASE.FAILED:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.START:
        default:
          return 'secondary';
      }
    },
    /** 表の情報 */
    systemTableColumns() {
      return [
        {
          name: "itemName",
          label: `${this.i18nWsKey}.label_table_item`
        },
        {
          name: "itemSelect",
          label: `${this.i18nWsKey}.label_table_select`,
          useButton: true
        }
      ];
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_100 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    /** 待機処理（NonDefaultSession） */
    async execute() {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'standby'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.WAIT;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** USB接続確認（ルーチン実行,ルーチン結果確認） */
    async executeStartProcess() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute-usb'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }

        switch (response.data.user_data.result) {
          case 'ok':
            // 地図更新エリア選択
            this.phase = PHASE.AREA_SELECT;
            // テーブル表示
            this.tableShow();
            break;
          case 'ng':
            // USB未接続表示
            this.phase = PHASE.USB_UNCONNECTED;
            break;
          default:
            // 該当のエラーコードが存在しない場合、汎用エラー
            this.showUnexpectedError();
            break;
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** 地図更新エリア選択 */
    /** 地図データVer確認（ルーチン実行,ルーチン結果確認） */
    async executeMapSelect(selected) {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute-map',
            area: selected.area
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }

        switch (response.data.user_data.result) {
          case 'ok':
            // 車両状態確認
            await this.vehicleCheck();
            break;
          case 'ng':
            // アップデート対象地図無し表示
            this.phase = PHASE.UPDATE_NOT_APPLICABLE;
            break;
          default:
            // 該当のエラーコードが存在しない場合、汎用エラー
            this.showUnexpectedError();
            break;
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** 車両状態確認（データ読出し） */
    async vehicleCheck() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }

        switch (response.data.user_data.result) {
          case 'ng':
            // 車両状態異常表示
            this.phase = PHASE.VEHICLE_ABNORMALITY;
            break;
          case 'ok':
            // 地図更新開始／地図更新状態確認へ遷移
            await this.mapUpdateStart();
            break;
          default:
            // 該当のエラーコードが存在しない場合、汎用エラー
            this.showUnexpectedError();
            break;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 地図更新開始／地図更新状態確認（ルーチン実行,ルーチン結果確認） */
    async mapUpdateStart() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute_with_security'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            switch (response.data.user_data.result) {
              case 'updating':
                // 地図更新中表示画面へ遷移
                this.phase = PHASE.UPDATE_WAIT;
                // requestIdを保持
                this.requestId = response.data.user_data.request_id;
                this.progress
                  = this.$t(`${this.i18nWsKey}.REQ_WS_100_TXT_3_${response.data.user_data.progress_rate}`);
                await this.mapUpdateWait();
                break;
              case 'success':
                // 地図更新成功表示画面へ遷移
                this.phase = PHASE.UPDATE_SUCCESS;
                break;
              case 'failure':
                // 地図更新失敗表示へ遷移
                this.showMapUpdatingError(response.data.user_data.failure_phase);
                break;
              default:
                // 汎用エラー
                this.showUnexpectedError();
                break;
            }
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 地図更新中表示画面 */
    async mapUpdateWait() {
      // sleep
      await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
      try {
        this.isLoading = true;
        // バックエンドAPI GETのみ
        const response = await individualDiagnose.syncApi(
          this,
          // GET API 呼び出しのコールバック
          async () => {
            return await api.getCall(
              config.WSP,
              '/netApps/' + this.netAppId + '/systems/' + this.systemId + '/workSupports/'
              + this.workSupportId + '/requests/' + this.requestId
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => { getApiResponse; return ''; },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data && response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            switch (response.data.user_data.result) {
              case 'updating':
                this.progress
                  = this.$t(`${this.i18nWsKey}.REQ_WS_100_TXT_3_${response.data.user_data.progress_rate}`);
                // 地図更新中表示画面へ遷移（再帰）
                await this.mapUpdateWait();
                break;
              case 'success':
                // 地図更新成功表示画面へ遷移
                this.phase = PHASE.UPDATE_SUCCESS;
                break;
              case 'failure':
                this.showMapUpdatingError(response.data.user_data.failure_phase);
                break;
              default:
                // 汎用エラー
                this.showUnexpectedError();
                break;
            }
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 地図更新成功表示画面 */
    /** NO押下時処理 */
    async updateSuccess() {
      // USB切断確認画面へ遷移
      this.phase = PHASE.USB_DISCONNECT;
    },
    /** YES押下時処理 */
    async mapSelect() {
      // 地図更新エリア選択画面へ遷移
      this.phase = PHASE.AREA_SELECT;
      // テーブル表示
      this.tableShow();
    },

    /** USB切断確認（ルーチン実行,ルーチン結果確認） */
    async usbDisconnect() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'monitor'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            switch (response.data.user_data.result) {
              case 'ng':
                // USB切断確認再表示
                break;
              case 'ok':
                // 地図更新完了表示
                this.phase = PHASE.SUCCESS;
                break;
              default:
                // 該当のエラーコードが存在しない場合、汎用エラー
                this.showUnexpectedError();
                break;
            }
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了：汎用エラー
            this.showUnexpectedError();
            return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 終了処理
     * @param {*} existence 0:エラー遷移あり, 1:エラー遷移なし 
     * @returns 
     */
    async exit(existence) {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (existence === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：汎用エラー
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** テーブル表示 */
    async tableShow() {
      this.$nextTick(() => {
        // リスト表示項目の設定
        this.bodyItems = [
          {
            area: 'northern',
            itemName: this.$t(`${this.i18nWsKey}.row_northern_europe`),
            buttonVisible: true
          },
          {
            area: 'western',
            itemName: this.$t(`${this.i18nWsKey}.row_western_europe`),
            buttonVisible: true
          },
          {
            area: 'eastern',
            itemName: this.$t(`${this.i18nWsKey}.row_eastern_europe`),
            buttonVisible: true
          },
          {
            area: 'southern',
            itemName: this.$t(`${this.i18nWsKey}.row_southern_europe`),
            buttonVisible: true
          },
          {
            area: 'other',
            itemName: this.$t(`${this.i18nWsKey}.row_other`),
            buttonVisible: true
          }
        ];
      });
    },

    /** 地図更新失敗表示画面 */
    showMapUpdatingError(failurePhase) {
      this.phase = PHASE.UPDATE_FAILED;
      this.updateFailureReference
        = this.$t(`${this.i18nWsKey}.REQ_WS_100_TXT_10_${failurePhase}`);
    },

    /** その他エラーの表示 */
    showUnexpectedError() {
      this.phase = PHASE.FAILED;
    },

    /**
        * API 通信で共通バリデーションでエラーが発生した際のコールバック
        * @param {object} result handler.validate で返ってきたバリデーション結果
        */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_100 = false;
    },
  },

  async mounted() {
    this.init();
    // 準備処理
    this.execute();
  },
};
